import { usePreferences } from "@react-admin/ra-preferences";
import I18nProvider from "../../../provider/I18nProvider";

const Loader = (props) => {
    const [theme] = usePreferences('theme', 'light');
    return <div className={`loading ${theme} ${props.className || ''}`}>
        <div className="content">
            <h1>{I18nProvider.translate("resources.loading")}</h1>
            <div className="lds-dual-ring">&nbsp;</div>
        </div>
    </div>;
};

export default Loader;